package haxe.ui.backend;

class BackendBase {
    public static var id:String = "html5";
}
